<template>
  <b-container  fluid>
    <b-row>
      <b-container>
          <b-row class="mx-0">
            <b-col sm="12" class="content  mb-0">
              <b-overlay :show="showOverlay" rounded="sm">
              <SearchForm :params="model.params" :results="model.results" @search="onSearch"/>
              </b-overlay>
            </b-col>
          </b-row>

        <b-row class="content" v-if="results.length">
          <b-col sm="12">
            <BookingResults
              :results="model.results"
              @view="onView"/>
            </b-col>
        </b-row>
      </b-container>
    </b-row>
  </b-container>
</template>

<script>
import model from './services/model'

import SearchForm from './components/search_form'
import BookingResults from './components/booking_results'

export default {
  name: 'BookingSearch',
  components: { SearchForm, BookingResults },
  data () {
    return {
      model,
      showOverlay: false,
      currentBooking: null
    }
  },
  computed: {
    results () {
      return model.results
    }
  },
  methods: {
    onSearch (params) {
      this.showOverlay = true
      model.search(params)
        .finally(() => { this.showOverlay = false })
    },
    onView (id) {
      this.$router.push({
        name: 'Private/Bookings/View',
        params: {
          Id: id
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
